import React from 'react'
import './transition-style.css'

const Transition = () => (<div className="transition"></div>)

export default Transition